<template>
    <div :class="{'zigbee-block': !deviceData.devices.length}">
        <div class="devices-list__block py-3 ma-0" v-if="deviceData">
            <v-layout pa-0 ma-0 column>
                <v-flex xs12 class="bold-text text-center mb-1">
                    {{deviceData.vendor}} {{deviceData.model}}
                    <div class="close-btn" v-if="canDelete" @click.stop.prevent="openModalDelete">
                        <v-img :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
                    </div>
                </v-flex>
                <v-flex xs12 class="main-block">
                    <v-flex v-if="deviceData.photo" xs12 class="device-photo" :style="{ backgroundImage: `url('${deviceData.photo}')` }"/>
                    <v-flex v-else class="d-inline-flex justify-center">
                        <v-img width="150px" height="150px" :src="require('@/assets/icons/question_icon.png')"></v-img>
                    </v-flex>
                    <div v-if="!deviceData.interview_completed" class="bottom-left">
                        <v-tooltip
                            top
                            :content-class="`arrow-down ${first ? 'arrow-first' : ''}`"
                            v-model="showInterviewCompleted"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-img
                                    class="d-inline-flex"
                                    width="24px"
                                    height="24px"
                                    :src="require('@/assets/icons/error_icon.svg')"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="showInterviewCompleted = true"
                                ></v-img>
                            </template>
                            <div class="main-text">
                                Интервью не пройдено до конца. <br>
                                Пожалуйста, повторите процесс привязки.
                            </div>
                        </v-tooltip>
                    </div>
                    <div class="top-right">
                        <v-tooltip
                            top
                            :content-class="`arrow-down ${last ? 'arrow-last' : ''}`"
                            v-model="showSupported"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-img
                                    v-if="deviceData.supported"
                                    class="d-inline-flex"
                                    width="24px"
                                    height="24px"
                                    :src="require('@/assets/icons/checked_icon.svg')"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="showSupported = true"
                                ></v-img>
                                <v-img
                                    v-else
                                    class="d-inline-flex"
                                    width="24px"
                                    height="24px"
                                    :src="require('@/assets/icons/cancel_icon.svg')"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="showSupported = true"
                                ></v-img>
                            </template>
                            <div class="main-text">
                                Устройство <span v-if="!deviceData.supported"> не </span> поддерживается
                            </div>
                        </v-tooltip>
                    </div>
                    <div v-if="deviceData.interviewing" class="centered">
                        <div>
                            <v-img class="connection-animate" height="42px" width="42px" :src="require('@/assets/icons/connection.png')"></v-img>
                        </div>
                        <div class="main-text"> Идёт интервью </div>
                    </div>
                    <div v-if="deviceData.is_new" class="top-left">
                        <div class="small-text red-text"> NEW </div>
                    </div>
                </v-flex>
                <v-flex xs12 class="small-text mt-1">
                    id устройства: {{deviceData.inner_number}}
                </v-flex>
            </v-layout>
            <ModalDeleteConfirm
                v-model="modalDelete"
                :close="closeModalDelete"
                :url="`/controllers/hotel-admin/delete-zigbee-device/${controller}/${device.inner_number}`"
                :update="updateDelete"
                :param="device.inner_number"
            >
                <template #deleteTitle>
                    Вы действительно хотите удалить <br> устройство?
                </template>
                <template #deleteSubtitle>
                    После удаления ZigBee устройство<br>
                    <span class="common-text">{{deviceData.vendor}} {{deviceData.model}}</span><br>
                    пропадёт из списка устройств и удалятся все созданные для него устройства
                </template>
            </ModalDeleteConfirm>
        </div>
        <v-layout class="zigbee-devices-list" ma-0 column v-if="deviceData.devices.length || deviceData.devices_for_creating.length">
            <v-flex
                xs12
                v-for="(device, index) in deviceData.devices"
                :key="index"
                class="d-flex justify-space-between zigbee-devices-list__row"
                @click="openDevicePage(device.uid)"
            >
                <div class="d-inline-flex align-center">
                    <v-tooltip top content-class="arrow-down" v-model="device.show_online">
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                class="d-inline-flex"
                                v-bind="attrs"
                                v-on="on"
                                @click.stop.prevent="device.show_online = true"
                            >
                                <div class="status-marker ml-2">
                                    <div :class="device.online ? 'green-color' : 'red-color'"></div>
                                </div>
                            </div>
                        </template>
                        <span class="main-text">{{device.online ? "online" : "offline"}}</span>
                    </v-tooltip>
                    <v-img class="mr-1 ml-2" height="26px" width="26px" :src="require(`@/assets/device-icons/${deviceTypes[device.device_type].img}.svg`)"></v-img>
                    <div class="main-text device-name">
                        {{ device.name }}
                    </div>
                </div>
                <div class="d-inline-flex align-center">
                    <div class="location-row text-left ma-0"> {{device.location}} </div>
                    <v-img
                        class="ml-1 trash-icon"
                        height="20px"
                        width="20px"
                        :src="require(`@/assets/icons/trash.svg`)"
                        @click.prevent.stop="openModalDeviceDelete(device)"
                    ></v-img>
                </div>
            </v-flex>
            <v-flex
                v-if="showAddBtn"
                xs12
                class="d-flex justify-center zigbee-devices-list__row pt-1"
                @click="openAddDevicePage"
            >
                <div class="btn-add">+</div>
            </v-flex>
        </v-layout>
        <ModalDeleteConfirm
            v-model="modalDeviceDelete"
            :close="closeModalDeviceDelete"
            :url="`/devices/hotel-admin/devices/${chosenDeviceDelete.uid}/`"
            :update="update"
            :param="getUpdatedDevice"
        >
            <template #deleteTitle>
                Вы действительно хотите удалить <br> устройство?
            </template>
            <template #deleteSubtitle>
                После удаления устройство<br>
                <span class="common-text">{{chosenDeviceDelete.name}}</span><br>
                пропадёт из списка устройств
            </template>
        </ModalDeleteConfirm>
    </div>
</template>

<script>
import ModalDeleteConfirm from "@/components/modals/ModalDeleteConfirm";
import PlusIcon from "@/assets/icons/PlusIcon";
import deviceTypes from '@/plugins/deviceTypes.js';

export default {
    name: "ZigbeeDevice",
    components: {ModalDeleteConfirm, PlusIcon},
    props: {
        device: {
            type: Object,
            required: true,
        },
        controller: {
            type: String,
            required: true,
        },
        first: {
            type: Boolean,
            required: false,
        },
        last: {
            type: Boolean,
            required: false,
        },
        update: {
            type: Function,
            default: () => {},
        },
        updateDelete: {
            type: Function,
            default: () => {},
        },
        canDelete: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            showSupported: false,
            showInterviewCompleted: false,
            modalDelete: false,
            modalDeviceDelete: false,
            chosenDeviceDelete: {},
            deviceTypes: deviceTypes,
        };
    },
    created() {
        this.deviceData = this.device;
    },
    computed: {
        getUpdatedDevice() {
            if (this.chosenDeviceDelete.uid) {
                let devices = JSON.parse(JSON.stringify(this.device.devices));
                let deletedDevice = devices.map(device => {
                    return device.uid
                }).indexOf(this.chosenDeviceDelete.uid);
                if (deletedDevice != -1) {
                    devices.splice(deletedDevice, 1);
                }
                return {device: {...this.device, devices: devices }};
            }
            return null;
        },
        showAddBtn() {
            if (this.deviceData.devices_for_creating.length) {
                return this.deviceData.devices_for_creating.filter((el) => {
                    return el.available;
                }).length;
            }
            return false;
        },
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openModalDelete() {
            this.modalDelete = true;
        },
        closeModalDelete() {
            this.modalDelete = false;
        },
        openModalDeviceDelete(device) {
            this.chosenDeviceDelete = device;
            this.modalDeviceDelete = true;
        },
        closeModalDeviceDelete() {
            this.chosenDeviceDelete = {};
            this.modalDeviceDelete = false;
        },
        openAddDevicePage() {
            if (this.$route.name == "debugcontrollerpage") {
                this.$router.push({ name: "devicepage", params: { id: this.controller }, query: { wired: this.deviceData.inner_number } });
                return;
            }
            this.$router.push({ name: "devicepage", params: { id: this.controller }, query: { zigbee: this.deviceData.inner_number } });
        },
        openDevicePage(device) {
            if (this.$route.name == "debugcontrollerpage") {
                this.$router.push({
                    name: "devicepage",
                    params: { id: this.controller },
                    query: { wired: this.deviceData.inner_number, device: device }
                });
                return;
            }
            this.$router.push({
                name: "devicepage",
                params: { id: this.controller },
                query: { zigbee: this.deviceData.inner_number, device: device }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.zigbee-block {
    margin-bottom: 30px;
}

.zigbee-devices-list {
    background-color: rgba(247, 247, 249, 0.5);
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    top: -30px;
    position: relative;
    padding: 38px 12px 12px 12px;
    z-index: 1;

    &__row:not(:last-child) {
        padding: 8px 0;
        border-bottom: 1px solid #787878;
    }

    &__row:hover {
        cursor: pointer;
    }

    .btn-add {
        width: 100%;
        height: 34px;
        padding: 10px;
        border-radius: 8px;
        display: inline-flex;
        justify-content: center;
        align-items: center;

        &:hover {
            background-color: rgb(171,169,174,0.2);
            cursor: pointer;
        }
    }
}

.devices-list__block {
    position: relative;
    z-index: 2;

    .close-btn {
        position: absolute;
        right: 20px;
        top: 8px;
    }
}

.main-block {
    width: 100%;
    background: #FFFFFF;
    border-top: 1px solid #787878;
    border-bottom: 1px solid #787878;
    display: inline-grid;
    justify-content: center;
    align-items: center;
    position: relative;

    .device-photo {
        background-repeat: no-repeat;
        background-size: cover;
        min-height: 150px;
        min-width: 150px;
        height: 150px;
        width: 150px;
        margin: 10px 0;
    }

    .bottom-left,
    .top-right,
    .top-left {
        position: absolute;
    }

    .bottom-left {
        bottom: 2px;
        left: 2px;
        height: 24px;
        width: 24px;
        cursor: pointer;
    }

    .top-right {
        top: 8px;
        right: 2px;
        cursor: pointer;
    }

    .top-left {
        top: 8px;
        left: 2px;
    }

    .centered {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(33, 33, 33, 0.23);
        height: 150px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
}

.trash-icon {
    cursor: pointer;
    opacity: 0.4;

    &:hover {
        opacity: 1;
    }
}

.v-tooltip__content.menuable__content__active.arrow-down {
    &::before {
        content: '';
        position: absolute;
        left: 48%;
    }

    &.arrow-first {
        &::before {
            content: '';
            position: absolute;
            left: 18%;
        }
    }

    &.arrow-last {
        &::before {
            content: '';
            position: absolute;
            left: 70%;
        }
    }
}

.status-marker {
    align-items: center;
    display: inline-flex;

    .green-color,
    .red-color {
        height: 8px;
        width: 8px;
        border-radius: 6px;
    }

    .green-color {
        background: #42D829;
    }

    .red-color {
        background: #FF4F4F;
    }
}

.v-tooltip__content {
    background: linear-gradient(180deg, #FFF4BC 0%, rgba(255, 132, 132, 0.8) 100%);
    border-radius: 30px;
    padding: 16px;

    &.menuable__content__active {
        opacity: 1;

        &.arrow-down {
            overflow: inherit !important;
            z-index: 7;

            &::before {
                content: '';
                position: absolute;
                left: 50%;
                top: 100%;
                border: 5px solid #FF8484;
                border-color: #FF8484 transparent transparent transparent;
                opacity: 0.8;
            }
        }
    }
}

.location-row {
    color: #9A9B9E;
    font-size: 13px;
    line-height: 16px;
    text-align: end;
}

.device-name {
    overflow-wrap: anywhere;
}

.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}
</style>